<div>
	<ng-content select="[uwTwoColumnMicroLayoutLeft]"></ng-content>
</div>

<div>
	<ng-content select="[uwTwoColumnMicroLayoutMiddle]"></ng-content>
</div>

<div>
	<ng-content select="[uwTwoColumnMicroLayoutRight]"></ng-content>
</div>
